import { RootState } from '../index';
import { Site, StoreStatus } from '../../core/types/common.types';

export const errorSelector = (state: RootState): any | null => state.sites.errors || null;

export const isBusySelector = (state: RootState): boolean => state.sites.status === StoreStatus.BUSY;

export const responseSelector = (state: RootState): Site[] | any => state.sites.response || [];

export const hasSuccessSelector = (state: RootState): boolean => (state.sites.response ? true : false);
